import { disableReactDevTools } from '@fvilers/disable-react-devtools'

if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    disableReactDevTools();
    console.log = () => { };
    console.warn = () => { };
    console.error = () => { };
}